query MobileAppIdFilterOptions($limit: Int = 1000) {
	msdkApps: msdk_report_runs(limit: $limit, group: [app_id]) {
		app_id
	}
}
